// businesslocations/LocationForm.js
import { useEffect, useState } from "react";
import { useBusinessAuthContext } from "../commoncomponents/useBusinessAuthContext";
import API_URL from "../../api/API";

const LocationForm = ({ onSuccess, existingLocation = null }) => {
  const { business } = useBusinessAuthContext();

  const [states, setStates] = useState([]);
  const [counties, setCounties] = useState([]);

  const [form, setForm] = useState({
    name: "",
    street: "",
    city: "",
    state: "",
    county: "",
    zip: "",
  });

  // ✅ Populate when editing
  useEffect(() => {
    if (existingLocation) {
      setForm({
        name: existingLocation.name || "",
        street: existingLocation.street || "",
        city: existingLocation.city || "",
        state: existingLocation.state || "",
        county: existingLocation.county || "",
        zip: existingLocation.zip || "",
      });
    }
  }, [existingLocation]);

  useEffect(() => {
    fetch(API_URL.BUSINESS_STATE_LIST, {
      headers: {
        Authorization: `Bearer ${business.token}`,
        "x-session-id": business.sessionId,
      },
    })
      .then((r) => r.json())
      .then((d) => d.success && setStates(d.states));
  }, [business]);

  //load counties when state changes
  useEffect(() => {
    if (!form.state) {
      setCounties([]);
      return;
    }

    fetch(
      `${API_URL.BUSINESS_COUNTY_LIST}?state=${encodeURIComponent(form.state)}`,
      {
        headers: {
          Authorization: `Bearer ${business.token}`,
          "x-session-id": business.sessionId,
        },
      }
    )
      .then((r) => r.json())
      .then((d) => {
        if (d.success) {
          setCounties(d.counties);
        } else {
          setCounties([]);
        }
      })
      .catch(() => {
        setCounties([]);
      });
  }, [form.state, business]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
      ...(name === "state" ? { county: "" } : {}),
    }));
  };

  const handleSave = async () => {
    const url = existingLocation
      ? `${API_URL.BUSINESS_UPDATE_LOCATION}/${existingLocation._id}`
      : API_URL.BUSINESS_ADD_LOCATION;

    const method = existingLocation ? "PUT" : "POST";

    const res = await fetch(url, {
      method,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${business.token}`,
        "x-session-id": business.sessionId,
      },
      body: JSON.stringify(form),
    });

    const data = await res.json();
    if (data.success) onSuccess(data.location);
    else alert(data.message);
  };

  const inputClass =
    "w-full border border-gray-200 rounded-xl px-4 py-3 bg-gray-50 focus:outline-none focus:ring-2 focus:ring-yellow-400";

  return (
    <div className="space-y-5">
      <div>
        <label className="text-sm font-medium text-gray-700 mb-1 block text-left">
          Location Name
        </label>
        <input
          name="name"
          placeholder="e.g., Downtown Fitness Center"
          value={form.name}
          onChange={handleChange}
          className={inputClass}
        />
      </div>

      <div>
        <label className="text-sm font-medium text-gray-700 mb-1 block text-left">
          Street Address
        </label>
        <input
          name="street"
          placeholder="e.g., 123 Main Street"
          value={form.street}
          onChange={handleChange}
          className={inputClass}
        />
      </div>

      <div className="grid grid-cols-4 gap-4">
        <div>
          <label className="text-sm font-medium text-gray-700 mb-1 block text-left">
            City
          </label>
          <input
            name="city"
            value={form.city}
            onChange={handleChange}
            className={inputClass}
          />
        </div>

        <div>
          <label className="text-sm font-medium text-gray-700 mb-1 block text-left">
            State
          </label>
          <select
            name="state"
            value={form.state}
            onChange={handleChange}
            className={inputClass}
            required
          >
            <option value="">Select</option>
            {states.map((s) => (
              <option key={s} value={s}>
                {s}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="text-sm font-medium text-gray-700 mb-1 block text-left">
            County
          </label>

          <select
            name="county"
            value={form.county}
            onChange={handleChange}
            className={inputClass}
            disabled={!form.state}
            required
          >
            <option value="">
              {form.state ? "Select County" : "Select State First"}
            </option>

            {counties.map((county) => (
              <option key={county} value={county}>
                {county}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="text-sm font-medium text-gray-700 mb-1 block text-left">
            Zip Code
          </label>
          <input
            name="zip"
            value={form.zip}
            onChange={handleChange}
            className={inputClass}
          />
        </div>
      </div>

      <button
        onClick={handleSave}
        className="w-full bg-yellow-400 hover:bg-yellow-500 text-black font-semibold rounded-xl py-3 mt-2 shadow-sm"
      >
        {existingLocation ? "Update Location" : "Add Location"}
      </button>
    </div>
  );
};

export default LocationForm;